import {
  AvocadoIcon,
  BunInTheOvenIcon,
  HeartPuzzleIcon,
  ShootingStarIcon,
} from 'baby-ui/foundation/BabylistIcons/BabylistIcons'
import { useMediaQuery, useTheme } from '@material-ui/core'
import {
  // @ts-ignore
  useTracking,
  // @ts-ignore
  withContextualizedTracking,
  // @ts-ignore
  track,
} from 'lib/analytics'
import Slide from '../../Slide/Slide'
import {
  ButtonGroup,
  ButtonRect,
} from '../../OnboardingButtons/OnboardingButtons'
// eslint-disable-next-line import/no-named-as-default
import OneStepSignUpFlow from '../OneStepSignUpFlow/OneStepSignUpFlow'
import css from './road-ahead.styles.scss'
import TwoStepSignupFlow from '../TwoStepSignupFlow/TwoStepSignupFlow'

interface OptionDetails {
  planningStage: string
  path: string
  onboardingResponse: 'adoption' | 'stillTrying' | 'pregnancy' | 'surrogacy'
}

export interface RoadAheadProps {
  // eslint-disable-next-line @typescript-eslint/ban-types
  onSelectRoadAhead: (opts: OptionDetails) => void
  options: {
    ADOPTION: OptionDetails
    STILL_TRYING: OptionDetails
    PREGNANCY: OptionDetails
    SURROGACY: OptionDetails
  }
  onboardingFlow: string
}

function RoadAhead({
  onSelectRoadAhead,
  options,
  onboardingFlow,
}: RoadAheadProps) {
  const tracker = useTracking()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const nextPath = isMobile ? '/install-app' : '/add-button'

  function handleOnClick(opts: OptionDetails) {
    tracker.trackEvent({
      event: track.onboardingQuestionAnswered,
      eventLocation: track.EventLocation.ONBOARDING_MINUS_ROAD_AHEAD,
      answer: opts.onboardingResponse,
    })
    onSelectRoadAhead(opts)
  }
  if (onboardingFlow === 'one-step') {
    return <OneStepSignUpFlow nextPath={nextPath} />
  }
  if (onboardingFlow === 'two-step') {
    return <TwoStepSignupFlow nextPath={nextPath} />
  }
  return (
    <div className={css.RoadAhead__container}>
      <Slide
        className={css.RoadAhead__slide}
        title="The road ahead is filled with adventure. Where are you in your journey?"
      >
        <ButtonGroup>
          {/* @ts-ignore */}
          <ButtonRect
            className={css.RoadAhead__button}
            onClick={() => handleOnClick(options.PREGNANCY)}
          >
            <BunInTheOvenIcon />
            <div className="h3 mtm mbn">Pregnancy</div>
          </ButtonRect>
          {/* @ts-ignore */}
          <ButtonRect
            className={css.RoadAhead__button}
            onClick={() => handleOnClick(options.ADOPTION)}
          >
            <HeartPuzzleIcon />
            <div className="h3 mtm mbn">Adoption</div>
          </ButtonRect>
          {/* @ts-ignore */}
          <ButtonRect
            className={css.RoadAhead__button}
            onClick={() => handleOnClick(options.SURROGACY)}
          >
            <AvocadoIcon />
            <div className="h3 mtm mbn">Surrogacy</div>
          </ButtonRect>
          {/* @ts-ignore */}
          <ButtonRect
            className={css.RoadAhead__button}
            onClick={() => handleOnClick(options.STILL_TRYING)}
          >
            <ShootingStarIcon />
            <div className="h3 mtm mbn">Trying</div>
          </ButtonRect>
        </ButtonGroup>
      </Slide>
    </div>
  )
}

export default withContextualizedTracking()(RoadAhead)
